export default __webpack_public_path__ + "assets/bg_new-1d324a489207d5f8e45f20d2b4d5d12f.png";